export const sanitizeCustomerPhone = (raw, { maxDigits = 10 } = {}) => {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "";
  return digits.slice(0, Math.max(0, Number(maxDigits) || 0));
};

export const validateCustomerName = (name, { required = true } = {}) => {
  const value = String(name || "").trim();
  if (!value) {
    return required ? "Customer name is required." : "";
  }
  if (value.length < 2) {
    return "Customer name must be at least 2 characters.";
  }
  return "";
};

export const validateCustomerPhone = (phone, { required = true } = {}) => {
  const sanitized = sanitizeCustomerPhone(phone, { maxDigits: 10 });

  if (!sanitized) {
    return required ? "Customer phone is required." : "";
  }

  if (sanitized.length !== 10) {
    return "Please fill a valid 10 digit number.";
  }

  return "";
};

export const validateCustomerEmail = (email, { required = true } = {}) => {
  const value = String(email || "").trim();
  if (!value) {
    return required ? "Customer email is required." : "";
  }

  // Keep this intentionally simple (frontend-only) to avoid rejecting valid edge cases.
  const basicEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!basicEmail.test(value)) {
    return "Customer email format is invalid.";
  }

  return "";
};

export const validateCustomerDetails = (
  { name, phone, email },
  { requireAll = true, requireEmail = true } = {},
) => {
  const nameError = validateCustomerName(name, { required: requireAll });
  if (nameError) return { ok: false, field: "name", message: nameError };

  const phoneError = validateCustomerPhone(phone, { required: requireAll });
  if (phoneError) return { ok: false, field: "phone", message: phoneError };

  const emailError = validateCustomerEmail(email, {
    required: requireAll && requireEmail,
  });
  if (emailError) return { ok: false, field: "email", message: emailError };

  return { ok: true, field: null, message: "" };
};
